import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { useDispatch } from 'react-redux';
import { vendorApi } from '@/redux/api/vendorApi';
import { PATHS } from '@/navigation/paths';
import LoadingSkeleton from '@common/feedback/LoadingSkeleton';

/**
 * A path on this site: one leading slash, never two (`//host` would leave
 * the site). Anything else lands on the Stripe Connect page.
 */
const isSiteRelativePath = (value) =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//');

/**
 * Handles the redirect back from Stripe onboarding, whether the vendor
 * finished, left, or hit an expired link (the return and refresh routes
 * both mount this).
 *
 * Invalidates cached account and setup data before navigating so the page
 * they land on fetches fresh status instead of showing stale data, then
 * lands them where they started (#1158, Tyler 2026-09-21: "back to
 * whatever screen they were on when they left it"): the backend put that
 * page in the return URL's `to`. Without one, the Stripe Connect page.
 */
const StripeOnboardingReturn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const to = searchParams.get('to');

  useEffect(() => {
    dispatch(vendorApi.util.invalidateTags(['ConnectedAccount', 'VendorSetup']));
    navigate(isSiteRelativePath(to) ? to : PATHS.dashboard.store.revenue, { replace: true });
  }, [dispatch, navigate, to]);

  return <LoadingSkeleton type='page' />;
};

export default StripeOnboardingReturn;
